// extracted by mini-css-extract-plugin
export default {"Title":"Matting_Title__VoDbU","Controller":"Matting_Controller__2qWq7","Content":"Matting_Content__HYHqE","DragAndScale":"Matting_DragAndScale__eMFMW","Tips":"Matting_Tips__7pJXA"};